import { useState } from 'react';
import { CollapseContext } from './collapseContext';
import CollapseToggle from './CollapseToggle';
import CollapseMenu from './CollapseMenu';

const FUCollapse = ({ children, open, toggleCollapse }) => {
    const [collapseOpen, setCollapseOpen] = useState(false);

    const handleCollapse = () => {
        setCollapseOpen(!collapseOpen);
    };

    return (
        <CollapseContext.Provider
            value={{
                open: open ?? collapseOpen,
                handleCollapse: toggleCollapse ?? handleCollapse,
            }}
        >
            {children}
        </CollapseContext.Provider>
    );
};

// Assign CollapseToggle and CollapseMenu as static properties on Collapse
FUCollapse.Toggle = CollapseToggle;
FUCollapse.Menu = CollapseMenu;

export default FUCollapse;